import React from 'react';
import { useNavigate } from 'react-router-dom';
import authStore from '../../store/authStore';
import { Bus, Building2, Ticket, LogOut, Eye, ChevronRight } from 'lucide-react';
import './SelezioneArea.css';

/**
 * Schermata di scelta dell'area, mostrata all'amministratore appena entra.
 *
 * Il gestionale è nato per il solo trasporto scolastico; ora convivono
 * più attività e tenerle in un unico menu lo renderebbe illeggibile.
 */
export const AREE = [
  {
    id: 'scolastico',
    nome: 'Trasporto Scolastico',
    descrizione: 'Clienti, abbonamenti, gruppi, corse e pagamenti',
    icona: Bus,
    percorso: '/admin/dashboard',
    attiva: true,
  },
  {
    // Quello che non appartiene a una sola attivita': i preventivi dei
    // noleggi, e i pullman con gli autisti, che servono tutte e tre le
    // aree.
    id: 'generale',
    nome: 'Generale',
    descrizione: 'Preventivi, committenti, pullman e autisti',
    icona: Building2,
    percorso: '/admin/preventivi',
    attiva: true,
  },
  {
    id: 'eventi',
    nome: 'Navette Eventi',
    descrizione: 'Eventi, navette, prenotazioni e biglietti',
    icona: Ticket,
    percorso: '/admin/eventi',
    attiva: true,
  },
];

const SelezioneArea = () => {
  const navigate = useNavigate();
  const { utente, logout } = authStore();
  const solaLettura = utente?.ruolo === 'SOLA_LETTURA';

  const esci = () => {
    logout();
    navigate('/login');
  };

  return (
    <div className="area-container">
      <div className="area-box">
        <div className="area-header">
          <img src="/logo.png" alt="Casella Noleggio Bus" className="area-logo" />
          <h1>Scegli l'area</h1>
          <p>Potrai cambiarla in qualsiasi momento dal menu</p>
        </div>

        {solaLettura && (
          <div className="area-avviso">
            <Eye className="w-4 h-4 shrink-0" style={{ marginTop: 1 }} />
            <span>
              Stai accedendo in sola consultazione: puoi vedere i dati ma non modificarli.
            </span>
          </div>
        )}

        <div className="area-griglia">
          {AREE.map((area) => {
            const Icona = area.icona;
            return (
              <button
                key={area.id}
                type="button"
                onClick={() => area.attiva && navigate(area.percorso)}
                disabled={!area.attiva}
                className={`area-scheda${area.attiva ? '' : ' non-attiva'}`}
              >
                <div className="area-icona">
                  <Icona className="w-6 h-6" />
                </div>
                <div className="area-titolo-riga">
                  <h3>{area.nome}</h3>
                  {area.attiva
                    ? <ChevronRight className="w-4 h-4" style={{ color: '#cbd5e1' }} />
                    : <span className="area-pastiglia">{area.nota}</span>}
                </div>
                <p>{area.descrizione}</p>
              </button>
            );
          })}
        </div>

        <div className="area-piede">
          <span className="area-utente">
            Accesso come <strong>{utente?.first_name || utente?.username}</strong>
          </span>
          <button type="button" onClick={esci} className="area-esci">
            <LogOut className="w-4 h-4" />
            Esci
          </button>
        </div>
      </div>

      <p className="area-recapiti">
        Ufficio 0823 741 491 · info@casellanoleggiobus.it
      </p>
    </div>
  );
};

export default SelezioneArea;
